//bg
//open envelope
//rest of elements
//1s delay for fade in
import { useEffect, useState } from "react";
import RSVPButton from "../../components/rsvp-button/rsvp-button";
import "./e-invite.scss";

export default function EInvite() {
  const heading_desktop = {
    src: `${process.env.PUBLIC_URL}/images/e-invite/theralloswedding_desktoptext.webp`,
    alt: "THE Rallos WEDDING",
  };
  const closed_env = {
    src: `${process.env.PUBLIC_URL}/images/e-invite/closedenvelope_evite.webp`,
    alt: "closed envelope",
  };
  const open_env = {
    src: `${process.env.PUBLIC_URL}/images/e-invite/openenvelope.webp`,
    alt: "open envelope",
  };
  const invite_paper = {
    src: `${process.env.PUBLIC_URL}/images/e-invite/paperinvite.webp`,
    alt: "invitation",
  };
  const seal = {
    src: `${process.env.PUBLIC_URL}/images/save-the-date/09_waxseal.png`,
    alt: "seal",
  };

  const [step, setStep] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setStep((prev) => {
        if (prev >= 4) {
          clearInterval(interval);
          return prev;
        }
        return prev + 1;
      });
    }, 700); // delay between fades

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="e-invite e-invite-bg width-100 display-flex flex-column align-center justify-center">
        <div
          className={`e-invite-fade e-invite-heading ${
            step >= 4 ? "show" : ""
          }`}
        >
          <img
            src={heading_desktop.src}
            alt={heading_desktop.alt}
            className="e-invite-mobile"
          />
          <img
            src={heading_desktop.src}
            alt={heading_desktop.alt}
            className="e-invite-desktop"
          />
        </div>
        <img
          src={closed_env.src}
          alt={closed_env.alt}
          className={`e-invite-fade e-invite-envelope-closed ${
            step >= 1 && step <= 4 ? "show" : ""
          } ${step >= 5 ? "hide" : ""}`}
        />
        <div
          className={`e-invite-fade e-invite-envelope-container ${
            step >= 1 ? "show" : ""
          }`}
        >
          <img
            src={open_env.src}
            alt={open_env.alt}
            className={`e-invite-fade e-invite-envelope ${
              step >= 4 ? "show" : ""
            }`}
          />
          <img
            src={seal.src}
            alt={seal.alt}
            className={`e-invite-fade e-invite-seal ${step >= 4 ? "show" : ""}`}
          />
          <div
            className={`e-invite-fade rsvp-redirect-container display-flex flex-column justify-center align-center  ${
              step >= 4 ? "show" : ""
            }`}
          >
            <a href="/" className="font-size-5">
              <button>theralloswedding.com</button>
            </a>
            <p className="cormorant-italic-400 padding-top-2">
              please visit our website for the location, attire, and other
              details.
            </p>
          </div>
        </div>
        <div
          className={`e-invite-fade e-invite-content-container ${
            step >= 4 ? "show" : ""
          }`}
        >
          <img
            src={invite_paper.src}
            alt={invite_paper.alt}
            className="paper-invite"
          />{" "}
          <img src={seal.src} alt={seal.alt} className="e-invite-seal-mobile" />
        </div>
      </div>
    </>
  );
}
